/**
 * resource component to display content module information in 
 * card form 
 * 
 * NOTE: unused in 1.15
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import { DateTime } from 'luxon';
import ReactTooltip from 'react-tooltip';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

import * as userModuleActions from '../../userModule/userModuleActions.js';

// import utilities
import videoUtils from '../../../global/utils/videoUtils.js';

const simUrl = window.simUrl;
// not updating links here because this should no longer be used with london handling agenda and certificates

class ModuleCertCard extends Base {
  constructor(props) {
    super(props);
    this.state = {
      trailerModalOpen: false 
    }
    this._bind(
      '_handleStartOver'
    )
  }

  _handleStartOver() {
    // TODO: athens 2.0 investigate
    const { dispatch, history, contentModule } = this.props;
    dispatch(userModuleActions.sendCreateUserModule({
      _contentModule: contentModule._id
    })).then(json => {
      if(json.success) {
        // TODO: CHECK IF WE TO INVALIDATE THE LIST OR ANYTHING HERE
        // created new one, now send them to it
        history.push(`/my-agenda/cms/${contentModule.slug}`)
      } else {
        alert(`ERROR: ${json.error}`);
      }
    })
  }

  render() {

    const {
      agendaItem
      , sponsorStore 
      , contentModule
    } = this.props;
  
    const {
      trailerModalOpen
    } = this.state;
  
    const pending = agendaItem.certificateStatus == "pending-attestation";
    const expired = agendaItem.certificateStatus == "expired"; 
    const expiringSoon = agendaItem.certificateStatus == 'expiring-soon'; 
    const completed = agendaItem._certificate ? true : false;  
    const required = !agendaItem.optional;
  
    const sponsor = sponsorStore.byId[contentModule._organization];
    let logoUrl = contentModule.brandingLogoUrl ? contentModule.brandingLogoUrl : (sponsor && sponsor.logo) ? sponsor.logo : "/img/cert-icons/cert-icon-empty@2x.png"; 

    const expirationDate = DateTime.fromISO(agendaItem._certificate.expires).toLocaleString(DateTime.DATE_MED)

    // let linkUrl = match.url; 
    let linkUrl = `/my-agenda`

    return (
      <div className="yt-col s_50 m_33 l_20">
      {/* Move all ReactTooltips to the root div of this component so that the stacking context allows the tooltip to display on top of everything else. */}
        <div id={`tm_${contentModule._id}`} className={`cert-card -${agendaItem._certificate.status}`}>
          <img src="/img/cert-item.jpg"/>
          <div className="-title"> {contentModule.title} </div>
          <div >
            <div className="yt-row center-vert space-between">
              { pending ?
                // 0. REQUIRES ATTESTATION BEFORE COMPLETE
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Verification Required</div>
                  <Link className="-button -expiring-soon" to={`/my-certificates/${agendaItem._certificate._id}`}>
                    Finish
                  </Link>
                </div>
              : agendaItem._certificate && !agendaItem.valid && agendaItem.userModuleTiedToLatestCert ?
                // 1. EXPIRED OR INVALID CERT, HAVEN'T RESTARTED - MUST RESTART
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Expired {expirationDate}</div>
                  {/* <button className="-button -expired" onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>
                </div>
              : agendaItem._certificate && !agendaItem.valid && agendaItem._userModule ?
                // 2. EXPIRED OR INVALID CERT, HAVE NEVER STARTED - MUST RESTART
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Expired {expirationDate}</div>
                  {/* <button className="-button -expired" onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>
                </div>
              : agendaItem._certificate && !agendaItem.valid ?
                // 3. EXPIRED OR INVALID CERT, ALREADY RESTARTED THOUGH
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Expired {expirationDate}</div>
                  <Link className="-button -expired" to={agendaItem._userModule && agendaItem._userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>
                    Continue Training
                  </Link>
                </div>
              : expiringSoon && agendaItem.userModuleTiedToLatestCert ?
                // 4. VALID CERT BUT EXPIRING SOON, MUST RESTART
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Valid through {expirationDate}</div>
                  {/* <button className="-button -expiring-soon" onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>                  
                </div>
              : expiringSoon ?
                // 5. VALID CERT BUT EXPIRING SOON, ALREADY RESTARTED
                <div className="yt-col bottom">
                  <div style={{marginBottom: '8px'}} className="-expires">Valid through {expirationDate}</div>
                  <Link className="-button -expiring-soon" to={agendaItem._userModule && agendaItem._userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>
                    Continue Training
                  </Link>
                </div>
              : agendaItem._certificate ?
                // 6. VALID CERT
                <div className="yt-col bottom" style={{marginTop: '16px'}}>
                  <div style={{marginBottom: '8px'}} className="-expires">Valid {agendaItem._certificate.expires ? `through ${expirationDate}` : null}</div>
                  <Link className="-button" to={`/my-certificates/${agendaItem._certificate._id}`}>
                    Print Certificate
                  </Link>
                </div>
              : agendaItem._userModule && agendaItem._userModule._lastNode ?
                // 7. NO CERTS BUT ALREADY STARTED MODULE
                <div className="yt-col bottom" style={{marginBottom: "8px", marginTop: '16px'}}>
                  <Link className="-button" to={`${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}`}>
                    Resume
                  </Link>
                </div>
              : 
                // 8. NO CERTS AT ALL, BEGIN
                <div className="yt-col _50" style={{marginBottom: "8px", marginTop: '16px'}}>
                  <Link className="-button" to={`${linkUrl}/cms/${contentModule.slug}`}>
                    Begin
                  </Link>
                </div>
              }
            </div>
          </div>
        </div>
        {/* <AlertModal
          alertMessage="Are you sure you want to restart your training?"
          alertTitle={"Confirm Restart Training"}
          closeAction={() => this.setState({confirmStartOver: false})}
          confirmAction={this._handleStartOver}
          confirmText={"Yes, continue"}
          declineAction={() => this.setState({confirmStartOver: false})}
          declineText={"Cancel"}
          isOpen={confirmStartOver}
          type="danger"
        /> */}
        <Modal
          btnColor='info'
          cardSize='jumbo'
          closeAction={() => this.setState({trailerModalOpen: false, contentModule: null})}
          isOpen={trailerModalOpen}
          modalClasses={'info'}
          modalHeader={contentModule.title}
          showButtons={false}
        >
          <VideoPlayer
            adminPreview={false}
            isAutoPlay={true}
            onVideoComplete={() => console.log('done playing')}
            playerId={contentModule._id}
            playlist={videoUtils.returnPlaylist(contentModule.trailerVidPath, contentModule.trailerPosterPath, null)}
            tracking={{
              description: "contentModuleCard-trailer"
              , _contentModule: contentModule._id
            }}
          />
        </Modal>
      </div>
    )
  }
}

ModuleCertCard.propTypes = {
  agendaItem: PropTypes.object.isRequired 
  , certificates: PropTypes.array 
  , dispatch: PropTypes.func.isRequired
  , contentModule: PropTypes.object.isRequired 
  , userModules: PropTypes.array
}

ModuleCertCard.defaultProps = {
  certificates: []
  , userModules: []
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sponsorStore: store.sponsor 
  }
}


export default withRouter(connect(mapStoreToProps)(ModuleCertCard));



// WEBPACK FOOTER //
// modules/agenda/components/ModuleCertCard.js.jsx